export default __webpack_public_path__ + "static/media/voice.3f87b1f4.gif";